module.exports = __webpack_public_path__ + "mainassets/img/phone.22d411f1.svg";